import { Component } from 'react';
import PropTypes from 'prop-types';

export default class HistoryContextComponent extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
}